//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { nodeI18n } from '../examples';
export default {
  props: {
    // 当前节点数据
    nodeData: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      // title编辑状态
      isEdit: false,
      // 标题名称
      nodeI18n: nodeI18n
    };
  },
  methods: {
    // 名称编辑
    changeEditState: function changeEditState(state) {
      var _this = this;
      this.isEdit = state;
      if (state) this.$nextTick(function () {
        return _this.$refs.editName.focus();
      });
    }
  }
};